import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { ValidationSchema } from '../_shared/validation'
import IdUnidadDeMedidaFormGroup from '../_shared/formGroups/idUnidadDeMedida'
import CodigoBarraFormGroup from '../_shared/formGroups/codigoBarra'
import EquivalenciaFormGroup from '../_shared/formGroups/equivalencia'

const EditarPresentacion = ({ handleClose, show, actualizarPresentacion, modalData }) => {
  const __adminContext = React.useContext(AdminContext)

  const formInitialValues = React.useMemo(
    () => ({
      _idUnidadDeMedida: modalData._idUnidadDeMedida || '',
      nombreUnidadDeMedida: modalData.nombreUnidadDeMedida || '',
      codigoBarra: modalData.codigoBarra || '',
      equivalencia: modalData.equivalencia || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    actualizarPresentacion({
      ...modalData,
      ...data
    })
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>EDITAR PRESENTACIÓN</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, handleChange, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <IdUnidadDeMedidaFormGroup
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                iError={errors._idUnidadDeMedida}
                iTouched={touched._idUnidadDeMedida}
                fIsSubmitting={isSubmitting}
              />
              <EquivalenciaFormGroup iError={errors.equivalencia} iTouched={touched.equivalencia} fIsSubmitting={isSubmitting} />
              {__adminContext.valoresConfiguracionCompania.flagCodigoBarra && (
                <CodigoBarraFormGroup iError={errors.codigoBarra} iTouched={touched.codigoBarra} fIsSubmitting={isSubmitting} />
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarPresentacion
